import { Dialog } from "@material-ui/core";
import { useEffect, useState } from "react";
import PriceRecalculationResultBox, { PriceRecalculationResult } from "./PriceRecalculationResultBox";

interface Props {
  priceUpdates: PriceRecalculationResult;
}

const PriceUpdatesConfirmationDialog = (props: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  
  const handleDialogClosed = () => {
    setDialogOpen(false);
  };

  useEffect(() => setDialogOpen(true), [props.priceUpdates]);

  return (
    <Dialog open={dialogOpen} onClose={handleDialogClosed}>
      <PriceRecalculationResultBox priceUpdates={props.priceUpdates} />
    </Dialog>
  );
};

export default PriceUpdatesConfirmationDialog;